import React from "react";

import moment from "moment";

import { AdminSection, Col, DatePicker, Option, Row, Select } from "components";

export const NotificationSettings = ({ notification, sendDate, setSendDate, setType }) => (
  <>
    <AdminSection
      headline="Notification settings"
      description="Choose the notification settings. If you send the notification now, first save the notification and send it through the notification list. Push notifications and emails will only be sent to people who have these enabled."
    />
    <Row>
      <Col sm={12} md={8}>
        <Select name="type" rules={[{ required: true }]} label="Type" onChange={(v) => setType(v)} initialValue={notification ? notification.type : "article"}>
          <Option value="feature">Klim feature</Option>
          <Option value="news">Klim news</Option>
          <Option value="article">New article</Option>
          <Option value="funding">New funding</Option>
        </Select>
      </Col>
      <Col sm={24} md={8}>
        <Select name="sendTypes" label="Send type" rules={[{ required: true }]} mode="multiple" initialValue={notification && notification.sendTypes}>
          <Option value="in-app">In-app</Option>
          <Option value="push">Push</Option>
          <Option value="email" disabled>
            Email
          </Option>
        </Select>
      </Col>
      <Col sm={12} md={8}>
        <DatePicker
          name="sendDate"
          label="Send date"
          rules={[{ required: true }]}
          format={["DD.MM.YYYY HH:00"]}
          showTime={{ format: "HH:00" }}
          showNow={false}
          disabledDate={(v) => v && v <= moment().startOf("day")}
          onChange={(v) => setSendDate(v.format("DD-MM-YYYY HH:00"))}
          initialValue={sendDate && sendDate}
        />
      </Col>
    </Row>
  </>
);
